import { render } from "./ResourcesFilters.vue?vue&type=template&id=ac0971ba&scoped=true"
import script from "./ResourcesFilters.vue?vue&type=script&lang=js"
export * from "./ResourcesFilters.vue?vue&type=script&lang=js"

import "./ResourcesFilters.vue?vue&type=style&index=0&id=ac0971ba&lang=sass&scoped=true"

import exportComponent from "../../../../../../opt/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ac0971ba"]])

export default __exports__